import PropTypes from "prop-types";

function Loading({icon = "spinner"}) {
  return <i className={`fa fa-${icon} fa-spin fa-2x`} />;
}

Loading.propTypes = {icon: PropTypes.string};

export default Loading;
